import React from 'react';

import DefaultGuides from "../../src/images/entrypage/default_guides.svg";
import { prepareOptionsForLocationSearch } from "../../src/js/helpers";
import TopMenu from "../SharedComponents/TopMenu";
import Footer from "../SharedComponents/Footer";

import './index.sass';


const Guides = ({ categories, footer, guides, regions, topMenu }) => {

  const regionsOptions = prepareOptionsForLocationSearch(regions);

  return (
    <div className="guides">

      <TopMenu
        {...topMenu}
        categories={categories}
        regionsOptions={regionsOptions}
        withSearch={true}
      />

      <div className="container">

        <div className="guides__headline">
          <h1>Oversigt over guides</h1>
          <p>Vi har samlet de bedste råd i en række artikler.</p>
        </div>

        <div className="guides__list row">
          { guides && guides.length &&
            guides.map(guide =>
              <div className="col-lg-6 guides__guide" key={`guide${guide.id}`}>
                <span className={guide.slug}>
                  <a href={`/guides/${guide.slug}`} className="guides__guide-link">
                    <img alt={guide.title}
                         className={`guides__guide-image lazyload ${guide.image && guide.image.url ? '' : 'default'}`}
                         data-src={(guide.image && guide.image.url) || DefaultGuides}
                         data-expand="100"
                         data-sizes="auto" />
                    <span>{ guide.title }</span>
                    <div className="guides__guide-background" />
                  </a>
                </span>
              </div>
            )
          }
        </div>
      </div>

      <Footer { ...footer } />

    </div>
  )
}

export default Guides;
